<template>
  <router-view v-slot="{ Component, route }">
    <!-- 不缓存 -->
    <component :is="Component" :key="route.name" />
  </router-view>
</template>

<script>
export default {
  name: "App",
  methods: {},
};
</script>

<style lang="scss" scoped>
$color: red;

div {
  font-size: 14px;
}
</style>
